/* eslint-disable react/button-has-type */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
/* global window */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get, find, toString } from 'lodash';
import { withTranslate } from 'react-redux-multilingual';
import {
	requestResearchHistory,
	researchIdMap,
	getResearchHistoryArgs
} from 'Actions/ResearchActions';
import MorningstarRating from 'components/MorningstarRating/MorningstarRating';
import InfoPopupModern from 'components/InfoPopup/InfoPopupModern';
import './StockMorningstarRating.scss';
import PdfLink from 'Views/Shared/LinkPdf/LinkPdf';

const StockMorningstarRating = props => {
	const { format } = window;
	const {
		xids,
		translate
	} = props;

	const dispatch = useDispatch();

	const venue = get(xids, 'venue');
	const researchItems = useSelector(state => get(state, 'researchData.researchHistoryData.items'));
	const morningstarItem = find(researchItems, researchItem => researchItem.FeedID === 2647 && researchItem.Companies.Company[0].XID === toString(venue));
	const date = get(morningstarItem, 'DocumentDate');
	const documentId = get(morningstarItem, 'documentId');
	const versionTag = get(morningstarItem, 'VersionTag');
	const starRating = parseInt(get(morningstarItem, 'Companies.Company.0.ProviderRatingNumeric', '0'), 10);

	useEffect(() => {
		if (!venue) {
			return;
		}
		dispatch(requestResearchHistory(researchIdMap.cibcResearchHistory, getResearchHistoryArgs([`${venue}`], 5), true));
	}, [venue]);

	return (
		<div className="stock-morningstar-rating">
			<div className="data-label">
				{translate('morningstarRating')}
				<InfoPopupModern size="small" leftShift={107}>
					{translate('morningstarStockTooltip')}
				</InfoPopupModern>
			</div>
			<div className="range-button">
				{ morningstarItem && <MorningstarRating stars={starRating} starSize="16px" /> }
				<div className="data-subtitle">{translate('overall')}</div>
				<div className="date">
					(
					{date ? format.monthDayYear(date) : format.errorValue()}
					)
				</div>
			</div>
			{ morningstarItem && (
				<div className="stock-open-pdf">
					<PdfLink
						className="pdf-link"
						researchId={researchIdMap.wgrResearchHistory}
						headline={translate('openPdf')}
						documentId={`${documentId}-${versionTag}`}
						docDate={date}
						inlineFileSize
						sourceOnSecondLine={false}
						hideFileSize
						anchorClassName="text"
						wcUSsuage />
				</div>
			) }
		</div>

	);
};

export default withTranslate(StockMorningstarRating);
